var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.isHaveNewMessage)?_c('audio',{ref:"audio",attrs:{"controls":"controls","hidden":"","src":"https://oss.mxclass.com/cathouse_pro/kefu/message.mp3"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }